<template>
  <ArticleView
    v-if="article"
    :article
    zone="article-detail"
    @close="navigate(activeModal!)"
  >
    <!-- Extend into the wide reader. The ≥768 gate lives inside the button. -->
    <template #actions>
      <ExtendButton
        :label="i18n(translations.extendLabel)"
        @click="handleExtend"
      />
    </template>
  </ArticleView>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import ExtendButton from '~/scopes/campaign/components/UI/ExtendButton.vue'
import ArticleView from '~/scopes/campaign/components/impacts/article/ArticleView.vue'
import { useModalState } from '~/scopes/campaign/composables/useModalState'

import translations from './ArticleDetail.translations'

const i18n = useI18n()
const { trackClick } = useTracking()
const {
  activeModal,
  activeArticle: article,
  navigate,
  openReader,
} = useModalState()
// Grow the same story into the centred reader. `?view=article` layers on this route, so
// the panel stays mounted underneath — which is what makes the focus restore on exit
// work — and the reader needs no id: the path already carries the article.
function handleExtend() {
  trackClick({
    zone: 'article-detail',
    name: 'extend',
    article: article.value?.slug,
    campaign: 'raw-materials',
  })
  openReader()
}
</script>
